export default __webpack_public_path__ + "static/ab-laptop-1-mobile-aa511ad8a487f03a9048430e36e48c57.jpg";